import React from 'react';

import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import IncidentsGraphsPublic from "../../../../components/Graph/IncidentGraphsPublic";


const IncidentAnalytics = () => {
    return <Container maxWidth="xxl" px={2}>
        <Card sx={{mt: 2, p: 3}}>
            <IncidentsGraphsPublic />
        </Card>
    </Container>
}

export default IncidentAnalytics;